import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { HebergementBnbaccess, AccesBnbaccess, AdresseBnbaccess } from './hebergement-bnbaccess.model';
import { HebergementBnbaccessService } from './hebergement-bnbaccess.service';
@Injectable()
export class HebergementBnbaccessPopupService {
    private isOpen = false;
    constructor (
        private modalService: NgbModal,
        private router: Router,
        private hebergementService: HebergementBnbaccessService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.hebergementService.find(id).subscribe(hebergement => {
                this.hebergementModalRef(component, hebergement);
            });
        } else {
            let hebergement = new HebergementBnbaccess();
            hebergement.acces = [];
            hebergement.adresse = new AdresseBnbaccess();
            return this.hebergementModalRef(component, hebergement);
        }
    }

    hebergementModalRef(component: Component, hebergement: HebergementBnbaccess): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.hebergement = hebergement;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/hebergement-bnbaccess-popup.service.ts